export function formatSeer(value: number): string {
  return Number(value.toFixed(1)).toString();
}
